import React from 'react';

export const subNavItems = []


// Flat map from child key → { label, route } used by shortcuts section
export const childrenMap = {}

export const moduleGroups = [
    {
        key: 'local-listings',
        label: 'Local Listings',
        titleKey: 'local_listings.label',
        children: [
            { key: 'locations', label: 'Listing Management', route: '/managelocations', checkId: 'MANAGE_LOCATIONS', titleKey: 'local_listings.listing_management.label' },
            { key: 'realitycheck', label: <>RealityCheck<sup>™</sup></>, route: '/realitycheck', checkId: 'MANAGE_LOCATIONS', titleKey: 'local_listings.reality_check.label' },
            { key: 'performance', label: 'Listing Performance', route: '/insights', checkId: 'INSIGHTS', titleKey: 'local_listings.listing_performance.label' },
            { key: 'image-management', label: 'Media Management', route: '/imagemanagement', checkId: 'IMAGE_MANAGEMENT', titleKey: 'local_listings.media_management.label' },
            { key: 'google-audit', label: 'Audit Logs', route: '/google-audit', checkId: 'GOOGLE_AUDIT', titleKey: 'local_listings.audit_logs.label' },
            { key: 'edit-history', label: 'Edit History', route: '/edit-history', checkId: 'MANAGE_LOCATIONS', titleKey: 'local_listings.edit_history.label' },
            { key: 'source-mapping', label: 'Source Mapping', route: '/source-mapping', checkId: 'MANAGE_LOCATIONS', titleKey: 'local_listings.source_mapping.label' },
        ],
    },
    {
        key: 'reputation',
        label: 'Reputation',
        titleKey: 'reputation.label',
        children: [
            { key: 'reviews', label: <>ReviewsInbox<sup>™</sup></>, route: '/reviews', checkId: 'REVIEWS', titleKey: 'reputation.reviews_inbox.label' },
            { key: 'rep-dashboard', label: 'Reviews Dashboard', route: '/dashboard', checkId: 'DASHBOARD', titleKey: 'reputation.reviews_dashboard.label' },
            { key: 'location-ratings', label: 'Location Ratings', route: '/location-ratings', checkId: 'DASHBOARD', titleKey: 'reputation.location_ratings.label' },
            { key: 'sentiment-analysis', label: 'Sentiment Analysis', route: '/sentiment-analysis', checkId: 'DASHBOARD', titleKey: 'reputation.sentiment_analysis.label' },
            { key: 'autoresponse', label: 'Auto Response', route: '/autoresponse', checkId: 'AUTO_RESPONSE', titleKey: 'reputation.auto_response.label' },
            { key: 'competitor', label: 'Competitor Reviews', route: '/competitor', checkId: 'COMPETITORS', titleKey: 'reputation.competitor_reviews.label' },
            { key: 'review-settings', label: 'Review Control', route: '/review-settings', checkId: 'REVIEW_SETTINGS', titleKey: 'reputation.review_controls.label' },
        ],
    },
    {
        key: 'local-social',
        label: 'Local Social',
        titleKey: 'local_social.label',
        children: [
            { key: 'posts', label: 'Posts & Showcases', route: '/posts/google-posts', matchRoute: '/posts', checkId: 'POST_SCHEDULE', titleKey: 'local_social.posts_showcases.label' },
            // { key: 'qareviews', label: 'Google Q&A', route: '/qareviews', hidden: true },
            { key: 'widgetshowcase', label: 'Review Showcase', route: '/widgetshowcase', checkId: 'REVIEW_SHOWCASE', titleKey: 'local_social.review_showcase.label' },
        ],
    },
    {
        key: 'reporting',
        label: 'Reporting',
        titleKey: 'reporting.label',
        children: [
            { key: 'report-management', label: 'Reports & Notices', route: '/report-management', checkId: 'REPORT_MANAGEMENT', titleKey: 'reporting.reports_notices.label' },
            { key: 'data-downloads', label: 'Data Studio', route: '/data-studio', checkId: 'DATA_DOWNLOADS', titleKey: 'reporting.data_studio.label' },
        ],
    },
    {
        key: 'ai-automations',
        label: 'AI & Automations',
        titleKey: 'ai_automations.label',
        children: [
            { key: 'manage-ai-agents', label: 'AI Agents', route: '/manage-ai-agents', checkId: 'PROFILE_DETAILS', titleKey: 'ai_automations.ai_agents.label' },
            { key: 'automations', label: 'Automations', route: '/automations', checkId: "REVIEWS", titleKey: 'ai_automations.automation_center.label' },
        ],
    },
    {
        key: 'calendar',
        label: 'Calendar',
        route: '/calendar',
        checkId: 'MANAGE_LOCATIONS',
        titleKey: 'calendar.label',
        children: [],
    },
]

// Populate flat map after array is defined
moduleGroups.forEach(mod => {
    if (mod.children.length === 0 && mod.route) {
        childrenMap[mod.key] = { key: mod.key, label: mod.label, titleKey: mod.titleKey, route: mod.route, matchRoute: mod.matchRoute, checkId: mod.checkId };
    }
    mod.children.forEach(child => {
        childrenMap[child.key] = { key: child.key, label: child.label, titleKey: child.titleKey, route: child.route, matchRoute: child.matchRoute, checkId: child.checkId };
    });
});

// Settings pages — not part of the modules list, but tracked so visiting
// them can still be pinned as a shortcut. label/iconName mirror the entries
// in Settings/childrens/SideBarRoutesList.js so shortcuts match exactly.
export const settingsRoutes = [
    { key: 'settings-profile', label: '23371', titleKey: 'settings.profile_settings.label', iconName: 'ti ti-photo', route: '/settings/profileSettings', checkId: 'PROFILE_DETAILS' },
    { key: 'settings-integrations', label: '11747', titleKey: 'settings.integrations.label', iconName: 'ti ti-plug', route: '/settings/integrations', checkId: 'INTEGRATIONS' },
    { key: 'settings-payment', label: '10323', titleKey: 'settings.billing.label', iconName: 'ti ti-credit-card', route: '/settings/payment', checkId: 'MANAGE_USERS', shouldSubscription: true, permissions: ['OWNER'] },
    { key: 'settings-inviteUser', label: '12541', titleKey: 'settings.invite_users.label', iconName: 'ti ti-users', route: '/settings/inviteUser', checkId: 'MANAGE_USERS' },
    { key: 'settings-manageRoles', label: '12538', titleKey: 'settings.manage_roles.label', iconName: 'ti ti-id-badge', route: '/settings/manageRoles', checkId: 'MANAGE_ROLES' },
    { key: 'settings-manageTeams', label: 'Manage Teams', titleKey: 'settings.manage_teams.label', iconName: 'ti ti-users-group', route: '/settings/manageTeams', checkId: 'MANAGE_TEAMS' },
    { key: 'settings-customNavigation', label: 'Navigation Control', titleKey: 'settings.navigation_control.label', iconName: 'ti ti-layout-navbar', route: '/settings/customNavigation', checkId: 'CUSTOME_SIDEBAR' },
    { key: 'settings-filterComposer', label: 'Filter Composer', titleKey: 'settings.filter_composer.label', iconName: 'ti ti-filter', route: '/settings/filterComposer', checkId: 'FILTER_COMPOSER' },
    { key: 'settings-savedTagsAndFilters', label: 'Saved Tags & Filters', titleKey: 'settings.saved_tags_filters.label', iconName: 'ti ti-bookmark', route: '/settings/savedTagsAndFilters', checkId: 'MANAGE_FILTERS' },
    {
        key: 'settings-claimLocation', label: 'Claim Location', titleKey: 'settings.claim_location.label', iconName: 'ti ti-map-pin', route: '/settings/claimLocation', checkId: 'CLAIM_LOCATION',
        permissions: [
            "hcoleman@localclarity.com",
            "iank@10thousandfeet.com",
            "keeferc@10thousandfeet.com",
            "arun@gmail.com",
            "arunnair@factweavers.com",
            "tsummy@localclarity.com",
            "inelson@localclarity.com",
            "antony-l@localclarity.com",
            "rahul@localclarity.com",
            "sidharth@localclarity.com",
            "amaiterth@localclarity.com",
            "scoleman@localclarity.com"
        ],
    },
];

settingsRoutes.forEach(item => {
    childrenMap[item.key] = {
        key: item.key,
        label: item.label,
        titleKey: item.titleKey,
        route: item.route,
        checkId: item.checkId,
        iconName: item.iconName,
        permissions: item.permissions,
        shouldSubscription: item.shouldSubscription,
    };
});
